import type { AxiosResponse } from "axios";
import { BASE_URL, httpClient } from "../config/develop-config";
export const authUrl = `${BASE_URL}/auth`;

export const getOverCreditApproveByComp = async (company: string) => {
  return await httpClient
    .get(`${authUrl}/over-credit-approver/approvers/${company}`)
    .then((res: AxiosResponse) => res.data)
    .catch((err) => console.log(err));
};
export const createOverCreditApprove = async (data: object) => {
  return await httpClient
    .post(`${authUrl}/over-credit-approver/create-group`, data)
    .then((res: AxiosResponse) => res.data)
    .catch((err) => console.log(err));
};
export const updateOverCreditApprove = async (data: object) => {
  return await httpClient
    .post(`${authUrl}/over-credit-approver/update`, data)
    .then((res: AxiosResponse) => res.data)
    .catch((err) => console.log(err));
};
export const deleteGroup = async (id: string, updateBy: string) => {
  return await httpClient
    .delete(`${authUrl}/over-credit-approver/group/${id}/${updateBy}`)
    .then((res: AxiosResponse) => res.data)
    .catch((err) => console.log(err));
};
export const deleteSequence = async (id: string, updateBy: string) => {
  return await httpClient
    .delete(`${authUrl}/over-credit-approver/sequence/${id}/${updateBy}`)
    .then((res: AxiosResponse) => res.data)
    .catch((err) => console.log(err));
};
export const deleteApprover = async (id: string, updateBy: string) => {
  return await httpClient
    .delete(`${authUrl}/over-credit-approver/approver/${id}/${updateBy}`)
    .then((res: AxiosResponse) => res.data)
    .catch((err) => console.log(err));
};
// get file ลายเซ็นต์ overCredit approver
export const getSignImg = async (object: object) => {
  return await httpClient
    .post(`${authUrl}/user-staff/get-sign-images`, object)
    .then((res: AxiosResponse) => res.data?.responseData)
    .catch((err) => console.log(err));
};
